export default __webpack_public_path__ + "static/media/gt.f6b8c0f1.svg";